<template>
    <table class="c-list-component c-list-component--loading  c-competences-cards">
        <tr v-for="n in rowCount" :key="n" class="c-list-row t-background-white">
            <td class="c-list-item c-list-item--default c-list-item--loading">
                <span class="c-list-item__label c-list-item__label"></span>
                <p class="c-list-item__value"></p>
            </td>
            <td class="c-list-item c-list-item--default c-list-item--loading">
                <span class="c-list-item__label"></span>
                <p class="c-list-item__value"></p>
            </td>
            <td class="c-list-item t-text-align-right c-list-item--loading">
                <span class="c-list-item__action"></span>
            </td>
        </tr>
    </table>
</template>

<script>
import ListComponent from '@/components/vue-components/list-component/ListComponent.vue';

export default {
    name: 'CompetenceCardsListLoading',
    props: {
        rowCount: {
            type: Number,
            default: 15
        }
    },
}
</script>
